// Componenti condivisi del pannello configurazione (Sprint 5).
// SettingsCard: card consistente, etichetta sezione + contenuto.
// FormRow: label + input layout standard.

import type { ReactNode } from 'react';

export function SettingsCard({
  kicker,
  title,
  description,
  children,
  rightSlot,
}: {
  kicker?: string;
  title: string;
  description?: string;
  children: ReactNode;
  rightSlot?: ReactNode;
}) {
  return (
    <div
      className="rounded-lg border p-6"
      style={{ background: 'var(--paper)', borderColor: 'var(--line)' }}
    >
      {kicker && (
        <div className="mb-2 mono text-xs" style={{ color: 'var(--mute)' }}>
          {kicker}
        </div>
      )}
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="serif text-2xl" style={{ color: 'var(--ink)' }}>
            {title}
          </h2>
          {description && (
            <p className="mt-1 text-sm" style={{ color: 'var(--mute)' }}>
              {description}
            </p>
          )}
        </div>
        {rightSlot}
      </div>
      {children}
    </div>
  );
}

export function FormRow({
  label,
  hint,
  error,
  children,
}: {
  label: string;
  hint?: string;
  error?: string;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="mb-1 block text-sm font-medium" style={{ color: 'var(--ink)' }}>
        {label}
      </span>
      {children}
      {hint && (
        <span className="mt-1 block text-xs" style={{ color: 'var(--mute)' }}>
          {hint}
        </span>
      )}
      {error && (
        <span className="mt-1 block text-xs" style={{ color: 'var(--danger)' }}>
          {error}
        </span>
      )}
    </label>
  );
}

export function inputStyle() {
  return {
    background: 'var(--paper)',
    borderColor: 'var(--line)',
    color: 'var(--ink)',
  } as const;
}

export function PrimaryButton({
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      {...props}
      className={`rounded-md px-4 py-2 text-sm font-medium shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed ${props.className ?? ''}`}
      style={{ background: 'var(--primary)', color: '#fff', ...props.style }}
    >
      {children}
    </button>
  );
}

export function SuccessHint({
  visible,
  message = 'Salvato',
}: {
  visible: boolean;
  message?: string;
}) {
  if (!visible) return null;
  return (
    <span className="mono text-xs" style={{ color: 'var(--primary)' }}>
      ✓ {message}
    </span>
  );
}
